import { Button } from '@uhg-abyss/web/ui/Button';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Text } from '@uhg-abyss/web/ui/Text';
import React from 'react';

import { adobeLinkTrackEvent } from '../../../../common/AdobeTagging/adobeLinkTrackEvent';
import { DividerStyle, LayoutGroupStyled } from './CompareSmartChoice.styled';

export const CompareFooter = ({
  removeItem,
  removeButtonText,
  filteredProviders,
}) => (
  <>
    <LayoutGroupStyled cssProps={{ minHeightAuto: true }} grow>
      {filteredProviders?.map((_, index) => (
        <React.Fragment key={index}>
          <DividerStyle />
        </React.Fragment>
      ))}
    </LayoutGroupStyled>
    <LayoutGroupStyled
      css={{ '& > div': { width: '100%', justifyContent: 'center' } }}
      cssProps={{ minHeightAuto: true }}
      grow
    >
      {filteredProviders?.map((provider, index) => (
        <Flex justify="center" key={index}>
          <Flex
            alignItems="center"
            data-auto-testid={`removed-provider-${provider?.locationId}`}
            data-testid={`removed-provider-${provider?.locationId}`}
            justify="center"
            onClick={() => {
              adobeLinkTrackEvent({
                name: 'Remove',
                location: 'Compare providers successful',
                type: 'Internal',
              });
              removeItem(provider?.locationId);
            }}
          >
            <Button color="destructive" size="$sm" variant="text">
              <IconSymbol
                color="#C40000"
                css={{
                  fontWeight: 'bold',
                  border: '2px solid #C40000',
                  borderRadius: '50%',
                }}
                icon="close"
                size={14}
              />
              <Text
                css={{
                  fontWeight: '600',
                  color: '#C40000',
                  cursor: 'pointer',
                  marginLeft: '$xs',
                }}
              >
                {removeButtonText}
              </Text>
            </Button>
          </Flex>
        </Flex>
      ))}
    </LayoutGroupStyled>
  </>
);
